/* eslint-disable
    no-use-before-define,
    no-var,
    radix,
*/
import d3 from 'd3'

export default BubblesService

/** @ngInject */
function BubblesService() {
    // init bubbles
    const Bubbles = function (conf) {
        const width = conf.width || 300
        const height = conf.height || 500
        const bubbleStrokeColor = conf.bubbleStrokeColor || '455469'
        const bubbleStrokeWidth = conf.bubbleStrokeWidth || '2'
        const fontFamily = conf.fontFamily || 'equipements'
        const isPictofont = conf.pictofont || true
        const type = conf.type || 'float'
        const jitter = conf.jitter || 0.013
        let data = []
        let node = null
        let label = null
        const margin = { top: 5, right: 0, bottom: 0, left: 0 }
        const maxRadius = conf.maxRadius || 30
        const rScale = d3.scale.sqrt().range([0, maxRadius])
        const collisionPadding = 3
        const minCollisionRadius = 12

        // return radius value from data passed to d3
        const rValue = (d) => parseInt(d.count)

        // return id from data passed to d3
        const idValue = function (d) {
            if (isPictofont) {
                return d.name.charCodeAt(0)
            }
            return d.name.charCodeAt(0)
        }

        // return text from data passed to d3
        const textValue = (d) => d.name[0]

        // transform data (random sort + parseInt count for safety as count is used to determine the radius)
        const transformData = function (rawData) {
            if (rawData && rawData.length) {
                rawData.forEach((d) => {
                    d.count = parseInt(d.count)
                    return rawData.sort(() => 0.5 - Math.random())
                })

                return rawData
            }
        }

        // tick function for force
        const tick = function (e) {
            const dampenedAlpha = e.alpha * 0.1
            node = d3.selectAll('.bubble-node')
            label = d3.selectAll('.bubble-label')

            const transform = (d) => `translate(${d.x},${d.y})`

            if (node) {
                // loop in all nodes to update position applying gravity + collision
                node
                .each(gravity(dampenedAlpha))
                .each(collide(jitter))
                .attr('transform', transform)

                // place label according to circle position as labels
                // are separated from circle due to SVG specs (no text elem in circle)
                return label
                .style('left', (d) => `${(margin.left + d.x) - (d.dx / 2)}px`)
                .style('top', (d) => `${(margin.top + d.y) - (d.dy / 2)}px`)
            }
        }

        // create force
        // gravity 1 and charge 1 to float
        // change to make it fall along with Y position in gravity
        let force = d3.layout.force()
          .gravity(1)
          .charge(1)
          .size([width, height])
          .on('tick', tick)

        const self = this
        self.data = null

        // chart object return by bubbles
        // chart inits the drawing by being passed to d3.call
        const chart = function (selection) {
            this.data = null
            const selfChart = this
            return selection.each(function (rawData) {
                // transforming the data
                data = transformData(rawData)

                // binding transformed data to bubbles for accessibility (adding, removing...)
                self.data = data

                // applying max radius size to all element
                const maxDomainValue = d3.max(data, (d) => rValue(d))

                // scale bubbles according to count parameter
                rScale.domain([0, maxDomainValue])

                // enter selector, create svg and bing data to svg
                const svg = d3.select(this).selectAll('svg').data([data])
                self.svg = svg
                const svgEnter = svg.enter().append('svg')
                svg.attr('width', width + margin.left + margin.right)
                svg.attr('height', height + margin.top + margin.bottom)

                // create group svg to group bubbles
                node = svgEnter.append('g').attr('id', 'bubble-nodes')
                .attr('transform', `translate(${margin.left},${margin.top})`)

                // create rectangle for bubble background (if needed)
                node.append('rect')
                .attr('id', 'bubble-background')
                .attr('width', width)
                .attr('height', height)

                // create lables which are html (not svg)
                label = d3.select(this).selectAll('#bubble-labels').data([data])
                  .enter()
                  .append('div')
                  .attr('id', 'bubble-labels')

                // draw
                return update()
            })
        }

        const update = () => {
            if (data && data.length) {
                data.forEach((d, i) => {
                    d.forceR = Math.max(minCollisionRadius, rScale(rValue(d)))
                })

                // May the force be with you
                force.nodes(data).start()

                updateNodes()
                return updateLabels()
            }
        }

        const updateNodes = function () {
            // get Bubbles and delete if exist (we don't want double drawing)
            node = node.selectAll('.bubble-node').data(data, (d) => idValue(d))
            node.exit().remove()

            // create bubbles in the svg and apply styles, force and connected events (drag&drop, tooltips in the future for rpu ?)
            return node.enter()
            .append('a')
            .attr('class', 'bubble-node')
            .attr('id', (d, i) => `nodes${idValue(d)}`)
            .style('stroke', bubbleStrokeColor)
            .style('stroke-width', bubbleStrokeWidth)
            .call(force.drag)
            .call(connectEvents)
            .append('circle')
            .attr('r', (d) => rScale(rValue(d)))
        }

        const updateLabels = function () {
            // same as bubbles
            label = label.selectAll('.bubble-label').data(data, (d) => idValue(d))
            label.exit().remove()

            const labelEnter = label.enter().append('a')
            .attr('class', 'bubble-label')
            .attr('id', (d, i) => `labels${idValue(d)}`)
            .call(force.drag)
            .call(connectEvents)

            labelEnter.append('div')
            .attr('class', 'bubble-label-name')
            .style('font-family', fontFamily)
            .text((d) => textValue(d))

            // scale font size according to bubble radius
            label
            .style('font-size', (d) => `${Math.max(8, rScale(rValue(d) / 1.6))}px`)
            .style('width', (d) => `${2.5 * rScale(rValue(d))}px`)

            // trick to center label in bubble
            label.append('span')
            .text((d) => textValue(d))
            .each(function (d) {
                d.dx = Math.max(2.5 * rScale(rValue(d)), this.getBoundingClientRect().width)
            })
            .remove()

            // reset the width of the label to the actual width
            label.style('width', (d) => `${d.dx}px`)

            return label.each(function (d) {
                d.dy = this.getBoundingClientRect().height
            })
        }

        // add function for adding label after drawing is init
        const addLabel = (data) => {
            const s = d3.select('#bubble-labels')

            const labelEnter = s.append('a').data(data)
            .attr('class', 'bubble-label')
            .attr('id', (d, i) => `labels${idValue(d)}`)
            .call(force.drag)
            .call(connectEvents)

            labelEnter.append('div')
            .attr('class', 'bubble-label-name')
            .style('font-family', fontFamily)
            .text((d) => textValue(d))

            labelEnter
            .style('font-size', (d) => `${Math.max(8, rScale(rValue(d) / 1.6))}px`)
            .style('width', (d) => `${2.5 * rScale(rValue(d))}px`)

            labelEnter.append('span')
            .text((d) => textValue(d))
            .each(function (d) {
                d.dx = Math.max(2.5 * rScale(rValue(d)), this.getBoundingClientRect().width)
            })
            .remove()

            return labelEnter.each(function (d) {
                d.dy = this.getBoundingClientRect().height
            })
        }

        // add function for adding nodes after drawing is init
        const addNode = function (data) {
            const nodeContainer = d3.select('#bubble-nodes')

            return nodeContainer
            .append('a')
            .data(data)
            .attr('id', (d, i) => `nodes${idValue(d)}`)
            .attr('class', 'bubble-node')
            .style('stroke', bubbleStrokeColor)
            .style('stroke-width', bubbleStrokeWidth)
            .call(force.drag)
            .call(connectEvents)
            .append('circle')
            .attr('r', (d) => rScale(rValue(d)))
        }

        // gravity force
        const gravity = function (alpha) {
            // if type is float let them stand at the top so y = 0 else means fall, make them go to the bottom and beyond (force will handle collision with svg borders)
            let cy
            if (type === 'float') {
                cy = 0
            } else {
                cy = height * 2
            }

            // alpha to correct speed of movement (useless for float), higher => faster
            const ay = alpha / 12

            // apply Y position to bubble (by tick)
            return function (d) {
                if ((d.y + (((cy - d.y) + (d.forceR * 3)) * ay)) < height) {
                    d.y += (cy - d.y) * ay
                }
            }
        }

        // collision force d3 spec
        const collide = (jitter) =>
        // returns the function below on each element
        (d) =>
          data.forEach((d2, index) => {
              // check if node and node in inner loop are not same
              if (d !== d2) {
                  // distance between both dots
                  const x = d.x - d2.x
                  const y = d.y - d2.y
                  let distance = Math.sqrt((x * x) + (y * y))

                  // min distance that is supposed to be to avoid collision
                  // first bubble radius + second bubble radius + padding (set padding to 0 if you don't want any space at all between bubbles)
                  const minDistance = d.forceR + d2.forceR + collisionPadding

                  if (distance < minDistance) {
                      // jitter is used to increase or decrease intensity of movement as it is done by tick
                      // higher jitter will make bubbles bounce further between each other
                      distance = ((distance - minDistance) / distance) * jitter
                      const moveX = x * distance
                      const moveY = y * distance

                      // we will push the current node 'backwards and the other node forward'
                      // for true gravity should try pushing d2 only if y is lower so bubble higher in the chart

                      let newX = d.x - moveX
                      if (newX < 0) {
                          if (((d.x + moveX) < width) && ((d.x + moveX) > 0)) {
                              newX = d.x + moveX
                          } else {
                              newX = rValue(d)
                          }
                      } else if (newX > width) {
                          if (((d.x + moveX) < width) && ((d.x + moveX) > 0)) {
                              newX = d.x + moveX
                          } else {
                              newX = width - rValue(d)
                          }
                      }

                      let newY = d.y - moveY
                      if (newY < 0) {
                          if (((d.y + moveY) < height) && ((d.y + moveY) > 0)) {
                              newY = d.y + moveY
                          } else {
                              newY = rValue(d) / 2
                          }
                      } else if (newY > height) {
                          if (((d.y + moveY) < height) && ((d.y + moveY) > 0)) {
                              newY = d.y + moveY
                          } else {
                              newY = height - (rValue(d) / 2)
                          }
                      }

                      let newXd2 = d2.x + moveX
                      if (newXd2 < 0) {
                          if (((d2.x - moveX) < width) && ((d2.x - moveX) > 0)) {
                              newXd2 = d2.x - moveX
                          } else {
                              newXd2 = rValue(d2)
                          }
                      } else if (newXd2 > width) {
                          if (((d2.x - moveX) < width) && ((d2.x - moveX) > 0)) {
                              newXd2 = d2.x - moveX
                          } else {
                              newXd2 = width - (rValue(d2) / 2)
                          }
                      }

                      let newYd2 = d2.y + moveY
                      if (newYd2 < 0) {
                          newYd2 = rValue(d2)
                      } else if (newYd2 > height) {
                          newYd2 = height - (rValue(d2) / 2)
                      }

                      // apply new positions
                      d.x = newX
                      d.y = newY
                      d2.x = newXd2
                      d2.y = newYd2

                      // if is last node check if nodes are still colliding, if yes, trust the force !
                      if (index === (self.data.length - 1)) {
                          let launched = 0
                          if (!launched) {
                              return (() => {
                                  const result = []
                                  for (let i = 0, end = self.data.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                                      let item
                                      if (self.data[index + 1]) {
                                          const nX = d.x - self.data[index + 1].x
                                          const nY = d.y - self.data[index + 1].y
                                          if (Math.sqrt((nX * nX) + (nY * nY)) > minDistance) {
                                              launched = 1
                                              item = force.nodes(self.data).start()
                                          }
                                      }
                                      result.push(item)
                                  }
                                  return result
                              })()
                          }
                      }
                  }
              }
          })



        // add function to add new node + label
        // public setter
        chart.add = function (data) {
            const index = findIndexByName(data.name)

            if (data && (typeof index === 'undefined')) {
                data = [data]
                self.data.push(data[0])
                force = d3.layout.force()
                  .gravity(0.1)
                  .charge(1)
                  .size([width, height])
                  .on('tick', tick)
            }

            const toCall = (selection) =>
              selection.each((rA) => {
                  rA = transformData(rA)
                  if (rA) {
                      rA.forEach((d, i) => {
                          d.forceR = Math.max(minCollisionRadius, rScale(rValue(d)))
                      })
                      force.nodes(self.data).start()

                      addNode(rA)
                      return addLabel(rA)
                  }
              })


            return d3.select('#vis')
            .datum(data)
            .call(toCall)
        }

        // flush all bubbles
        chart.flush = function () {
            const svgsLabels = d3.selectAll('.bubble-label')
            if (svgsLabels && (svgsLabels.length > 0)) {
                svgsLabels.remove()
            }

            const svgs = self.svg.selectAll('.bubble-node')
            if (svgs && (svgs.length > 0)) {
                svgs.remove()
            }
            self.data = []
        }

        // remove an existing bubble. Bubbles are identified by their name
        chart.remove = function (name) {
            const index = findIndexByName(name)
            const obj = { name }
            if (typeof index !== 'undefined') {
                const svgs = self.svg.selectAll(`#nodes${idValue(obj)}`)
                if (svgs && (svgs.length > 0)) {
                    svgs.remove()
                }
                const labels = d3.selectAll('#bubble-labels')
                const svgsLabels = d3.selectAll(`#labels${idValue(obj)}`)
                if (svgsLabels && (svgsLabels.length > 0)) {
                    svgsLabels.remove()
                }
                self.data.splice(index, 1)
                return force.nodes(self.data).start()
            }
            return null
        }

        // public getter to get current nodes displayed as data format
        chart.getData = () => self.data

        // public getter for displayed, true if chart is initiated
        chart.displayed = false

        // find index of bubble by its name
        const findIndexByName = function (name) {
            if (self.data) {
                for (let i = 0, end = self.data.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                    if (self.data[i] && (self.data[i].name === name)) {
                        return i
                    }
                }
            }
        }

        const connectEvents = function (d) {
            d.on('mouseover', mouseover)
            return d.on('mouseout', mouseout)
        }

        const mouseover = (d) => node.classed('bubble-hover', (p) => p === d)

        const mouseout = (d) => node.classed('bubble-hover', false)

        return chart
    }

    let plot = null

    const plotData = function (selector, data, plot) {
        d3.select(selector)
        .datum(data)
        .call(plot)

        plot.displayed = true
    }

    const display = function (conf) {
        plot = new Bubbles(conf)
        return plotData(conf.selector, conf.data, plot)
    }

    const add = (data) => plot.add(data)

    const remove = function (name) {
        if (plot) {
            return plot.remove(name)
        }
    }

    const getData = function () {
        if (plot) {
            return plot.getData()
        }
        return []
    }

    const isDisplayed = () => plot.displayed

    const flush = function () {
        if (plot && plot.displayed) {
            return plot.flush()
        }
    }

    return {
        display,
        add,
        remove,
        getData,
        isDisplayed,
        flush,
    }
}



// WEBPACK FOOTER //
// ./src/services/bubbles/service.js